import { useEffect, useState } from "react";
import { GlobalGet } from "../../../../helpers/fetcher";
import Environtment from "../../../../constant/environtment.json";

const Services = () => {
  const { REACT_APP_API_URL } = Environtment;
  const [dataReport, setDataReport] = useState([]);
  const [dataBusiness, setDataBusiness] = useState([]);
  const [dataHeader, setDataHeader] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchNews = async () => {
    try {
      const response = await GlobalGet({
        url: `${REACT_APP_API_URL}report`,
      });
      setDataReport(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);

  return {
    dataReport,
  };
};

export default Services;
